var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPictoVoiture = function SvgPictoVoiture(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 600",
    ref: ref,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 80.94,
    y: 139.38,
    width: 441.57,
    height: 318.17
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "picto_voiture") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M510.69,234.05a11.08,11.08,0,0,0-8.59-4.11H460c-10.38-27.34-23.88-54.2-39.23-64.31-53.17-35-194.27-35-247.43,0-15.36,10.11-28.86,37-39.29,64.31H92a11.13,11.13,0,0,0-10.86,13.35l6.27,30.15a11,11,0,0,0,10.8,8.81h12.48a74.59,74.59,0,0,0-17.94,48.84c-.1,21.63,8.11,41.13,23.13,55,.16.11.33.27.48.37v42.26A16.61,16.61,0,0,0,133,445.28h38.79a16.63,16.63,0,0,0,16.6-16.59v-17H405.75v17a16.61,16.61,0,0,0,16.6,16.59h38.79a16.63,16.63,0,0,0,16.6-16.59V387.25c15.88-14.54,23.51-34.59,23.62-54.63a74.61,74.61,0,0,0-18.82-50.37h13.3a11.11,11.11,0,0,0,10.86-8.81l6.22-30.15a11.28,11.28,0,0,0-2.23-9.24Zm-319.08-40.7c42.36-27.87,168.55-27.87,210.85,0,8.27,5.41,18.86,27.24,28.54,54H163.09c9.66-26.76,20.25-48.59,28.52-54ZM142,335.26A32.67,32.67,0,1,1,174.59,368,32.67,32.67,0,0,1,142,335.26Zm278,32.69a32.66,32.66,0,1,1,32.69-32.69A32.68,32.68,0,0,1,419.92,368Zm0,0"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPictoVoiture);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/picto_voiture.6c5ace6568f07fa2d4a946c78981d51c.svg";